// Typelizer digest 4859f930a0cf83a55254a78be428a9b2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** DELETE /c/:company_id/documents/:document_id/purchase_order */
  destroy: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/purchase_order', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/documents/:document_id/purchase_order */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/purchase_order', params, options),
    method: 'post',
  }),
}
